// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inviteteammember-component {
  width: 600px;
}
.inviteteammember-component .inviteteammember-button {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  margin-top: 20px;
}
.inviteteammember-component .inviteteammember-button > button:not(:first-child) {
  margin-right: 5px;
}
.inviteteammember-component .inviteteammember-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}
.inviteteammember-component .inviteteammember-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.inviteteammember-component .inviteteammember-content .form-group {
  margin-bottom: 0px;
}
.inviteteammember-component .inviteteammember-content .form-group label {
  color: #141718;
}
.inviteteammember-component .inviteteammember-container {
  flex-direction: row;
  width: 600px;
}
.inviteteammember-component .inviteteammember-column {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.inviteteammember-component .inviteteammember-row {
  display: flex;
  flex: 1 1;
}
.inviteteammember-component .inviteteammember-select-color {
  margin-left: 20px;
  width: 265px;
}
.inviteteammember-component .inviteteammember-name {
  width: 265px;
  height: 48px !important;
}
.inviteteammember-component .inviteteammember-name-input {
  height: 48px;
}
.inviteteammember-component .input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px;
}
.inviteteammember-component .icon-container {
  display: flex;
  align-items: center;
  padding: 4px;
}
.inviteteammember-component .search-icon {
  color: #999;
}
.inviteteammember-component .input-field {
  flex: 1 1;
  border: none;
  padding: 8px;
  font-size: 14px;
}
.inviteteammember-component .select-container-mail {
  width: 430px;
  border: "none";
  box-shadow: "none";
}
.inviteteammember-component .newcharlist-select-color-container {
  border: 1px solid #ced4da;
}
.inviteteammember-component .newcharlist-select-color {
  box-shadow: none;
  width: 265px;
}
.inviteteammember-component .newcharlist-panel {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
  background-color: #f8f8f8;
}
.inviteteammember-component .inviteteammember-card {
  margin-left: 30px;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/Components/InviteTeamMember/inviteteammember.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,aAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AACJ;AACI;EACE,iBAAA;AACN;AAGE;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,mBAAA;EACA,YAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AANJ;AASE;EACE,aAAA;EACA,SAAA;AAPJ;AAUE;EACE,iBAAA;EACA,YAAA;AARJ;AAWE;EACE,YAAA;EACA,uBAAA;AATJ;AAYE;EACE,YAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAZJ;AAeE;EACE,WAAA;AAbJ;AAgBE;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAdJ;AAiBE;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,yBAAA;AAhBJ;AAkBE;EACE,gBAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,8BAAA;AAlBJ","sourcesContent":[".inviteteammember-component {\n  width: 600px;\n  \n  .inviteteammember-button {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: flex-start;\n    margin-top: 20px;\n\n    > button:not(:first-child) {\n      margin-right: 5px;\n    }\n  }\n\n  .inviteteammember-content {\n    padding: 30px 24px 30px 24px;\n    gap: 24px;\n    background: #fefefe;\n    border: 1px solid #e8ecef;\n    border-radius: 12px;\n  }\n\n  .inviteteammember-content h4 {\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  .inviteteammember-content .form-group {\n    margin-bottom: 0px;\n  }\n\n  .inviteteammember-content .form-group label {\n    color: #141718;\n  }\n\n  .inviteteammember-container {\n    flex-direction: row;\n    width: 600px;\n  }\n\n  .inviteteammember-column {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  .inviteteammember-row {\n    display: flex;\n    flex: 1;\n  }\n\n  .inviteteammember-select-color {\n    margin-left: 20px;\n    width: 265px;\n  }\n\n  .inviteteammember-name {\n    width: 265px;\n    height: 48px !important;\n  }\n\n  .inviteteammember-name-input {\n    height: 48px;\n  }\n\n  .input-container {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 4px;\n  }\n\n  .icon-container {\n    display: flex;\n    align-items: center;\n    padding: 4px;\n  }\n\n  .search-icon {\n    color: #999;\n  }\n\n  .input-field {\n    flex: 1;\n    border: none;\n    padding: 8px;\n    font-size: 14px;\n  }\n\n  .select-container-mail {\n    width: 430px;\n    border: \"none\"; // Remove a borda\n    box-shadow: \"none\"; // Remove a sombra\n  }\n\n  .newcharlist-select-color-container {\n    border: 1px solid #ced4da;\n  }\n  .newcharlist-select-color {\n    box-shadow: none;\n    width: 265px;\n  }\n\n  .newcharlist-panel {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 16px;\n    background-color: #f8f8f8;\n  }\n\n  .inviteteammember-card {\n    margin-left: 30px;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
